import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";

export const walletApi = createApi({
  reducerPath: "walletApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getWalletTransactions: builder.query({
      query: ({ entity }: { entity: string }) => ({
        url: `/account/${entity}/ledger`,
        method: "GET",
      }),
      transformResponse: (response: any) => response.data,
    }),

    getLifetimeEarnings: builder.query({
      query: () => ({
        url: `/account/coins/ledger?sum=true&transaction_type=credit`,
        method: "GET",
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const { useGetWalletTransactionsQuery, useGetLifetimeEarningsQuery } =
  walletApi;
